document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".device-monitor-toggle").forEach(function (el) {
    el.addEventListener("click", function (e) {
      const tr = e.target.closest("tr");
      const device_id = tr.getAttribute("data-device-id");

      let method, data, url, confirm_msg;

      if (e.target.checked) {
        method = "POST";
        data = {
          device_monitor: {
            device_id: device_id,
          },
        };
        url = "/device_monitors";
        confirm_msg = "Monitor device?";
      } else {
        method = "DELETE";
        data = null;
        url = "/device_monitors/" + device_id;
        confirm_msg = "Stop monitoring device?";
      }

      if (confirm(confirm_msg)) {
        fetch(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              .content,
          },
          method: method,
          dataType: "JSON",
          body: JSON.stringify(data),
        }).then(function (_data) {
          tr.classList.add("highlight");
        });
      }
    });
  });
});
